import { buildQuery } from '@calendly/http-tools';
import { I18n } from '@calendly/i18n';
import { IconPlus } from '@calendly/ui/components/glyphs/IconPlus';
import { GroupTitle } from '@calendly/ui/components/menu';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { Link as RouterLink } from 'react-router-dom';
import { SETTINGS_SECTION } from 'features/settings_modal/constants';
import { useSettingsNavigation } from 'features/settings_modal/use_settings_navigation';
const containerCss = "c97kmvt";
const Header = ({
  scope,
  showNewLink,
  title
}) => {
  const {
    hrefForSettingsModalEntry
  } = useSettingsNavigation();
  const userGroupsUrl = hrefForSettingsModalEntry(SETTINGS_SECTION.adminPeople, '/app/admin/user_groups', 'groups');
  const inviteUrl = '/app/admin/invitations/new';
  const group = {
    team: {
      title: I18n.t('publisher.title.teams'),
      url: `/teams/new?${buildQuery({
        return_to: window.location.pathname + window.location.search
      })}`,
      linkTitle: I18n.t('publisher.event_types.new_team')
    },
    user: {
      title: I18n.t('publisher.title.users'),
      url: inviteUrl,
      linkTitle: I18n.t('publisher.organization.members.new_user')
    },
    user_group: {
      title: I18n.t('publisher.title.user_groups'),
      url: userGroupsUrl,
      linkTitle: I18n.t('publisher.organization.user_groups.new_group')
    }
  }[scope];
  return <GroupTitle className={containerCss}>
      <span>{title || group.title}</span>
      {showNewLink && <MinimalButton size="small" appearance="primary" leadingIcon={IconPlus} as={RouterLink} to={group.url}>
          {group.linkTitle}
        </MinimalButton>}
    </GroupTitle>;
};
export default Header;

require("./header.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");